// @flow
const COUNTRIES_WITH_SPECIAL_LENGTH_VALIDATION: Array<string> = ['tw']; // 1 char is allowed
const ONE_CHAR_LENGTH: number = 1;
const TWO_CHARS_LENGTH: number = 2;

/**
 * Return if min characters allowed are 1 or 2
 * depending on the countryCode
 */
export const getMinimumCharactersLengthByCountryCode = (countryCode: string): number =>
  COUNTRIES_WITH_SPECIAL_LENGTH_VALIDATION.indexOf(countryCode) > -1
    ? ONE_CHAR_LENGTH
    : TWO_CHARS_LENGTH;

/**
 * Validate an input string to have a minimum character length
 */
export const isValidInput = (input: ?string, minLength: number): boolean => {
  if (!input) {
    return false;
  }
  if (input.length < minLength) {
    return false;
  }

  return true;
};

/**
 * Given an object of key value inputs
 * at least one of them must have a minimum characters length
 *
 * @example
 *   const inputsObject = {
 *     what: 'javascript',
 *     where: 'barcelona'
 *   }
 */
export const atLeastOneInputIsValid = (inputsObject: Object, minLength: number): boolean =>
  Object.keys(inputsObject).some(item => {
    if (!inputsObject[item]) {
      return false;
    }
    if (inputsObject[item].length < minLength) {
      return false;
    }

    return true;
  });



// WEBPACK FOOTER //
// ./app/utils/validation.js